
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Switch',
  props: {
    id: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    ariaLabelledby: {
      type: String,
      default: ''
    },
    ariaDescribedby: {
      type: String,
      default: ''
    }
  },
  emits: ['update:checked'],
  methods: {
    handleInputChange(event: Event) {
      const target = event.target as HTMLInputElement;
      this.$emit('update:checked', target.checked);
    }
  }
});
